// extracted by mini-css-extract-plugin
export default {"container":"a48K1G","nameItem":"L1Kr_D","name":"VCk_Ar","link":"kI2LKK"};